import { useEffect, useState } from 'react';
import ReportPeriodService from '../shared/services/report-period/report-period.service';

export function useHasAReportPeriod(deps: any[] = []) {
  const reportPeriodService = new ReportPeriodService();
  const [hasAReportPeriod, setHasAReportPeriod] = useState<boolean | null>(null);
  useEffect(() => {
    reportPeriodService.getAllReportPeriod()
      .then(response => {
        setHasAReportPeriod(response.length > 0);
      })
      .catch(err => {
        console.log(err);
        setHasAReportPeriod(null);
      });
  }, deps);

  return hasAReportPeriod;
}
